const REGISTRY_KEY = '__memberNavRegistry';

function actions() {
    if (!window[REGISTRY_KEY]) {
        window[REGISTRY_KEY] = new Map();
    }
    return window[REGISTRY_KEY];
}

export function registerMemberNavAction(name, fn) {
    const key = String(name || '').trim();
    if (!key) {
        throw new Error('registerMemberNavAction: name is required');
    }
    if (typeof fn !== 'function') {
        throw new Error('registerMemberNavAction: fn is required');
    }
    actions().set(key, fn);
}

export function getMemberNavAction(name) {
    const key = String(name || '').trim();
    if (!key) {
        throw new Error('getMemberNavAction: name is required');
    }
    const fn = actions().get(key);
    if (typeof fn !== 'function') {
        throw new Error('getMemberNavAction: ' + key + ' is not registered');
    }
    return fn;
}

export function runMemberNavAction(name, ...args) {
    return getMemberNavAction(name)(...args);
}
